import { Ticket, TicketAttachment, TicketHistory, TicketHistoryList, TicketList } from '@/types/support/TicketType'
import {
  TicketHistoryResponse,
  TicketResponse,
  isTicketHistoryListResponse,
  isTicketListReponseType,
  isTicketResponse,
} from '@/types/support/TicketResponseType'
import { Translator } from '@/types/ApiResponseTypes'
import { parseIsoDate, parseIsoDateTime } from '@/utils/common'

class TicketResponseTranslator implements Translator<TicketList | TicketHistoryList | Ticket> {
  convert(response: any): TicketList | TicketHistoryList | Ticket {
    if (isTicketListReponseType(response)) {
      const ticketObjects: Array<Ticket> = []
      if (Array.isArray(response.tickets)) {
        response.tickets.forEach((ticket: TicketResponse) => {
          ticketObjects.push(this.convertToTicketModel(ticket))
        })
        return { total: response.total, page: response.page, tickets: ticketObjects }
      }
    }

    if (isTicketHistoryListResponse(response)) {
      const historyObjects: Array<TicketHistory> = []
      if (Array.isArray(response.histories)) {
        response.histories.forEach((history: TicketHistoryResponse) => {
          historyObjects.push(this.convertToTicketHistoryModel(history))
        })
        return { total: response.total, page: response.page, history: historyObjects.reverse() } as TicketHistoryList
      }
    }
    if (isTicketResponse(response)) {
      return this.convertToTicketModel(response)
    }
    return {} as TicketList
  }

  convertToTicketHistoryModel(history: TicketHistoryResponse): TicketHistory {
    const attachments = Array<TicketAttachment>()
    for (const file of history.attachments) {
      attachments.push({
        fileName: file.fileName,
        fileType: file.fileName,
        fileDate: parseIsoDateTime(file.fileDate),
        fileUrl: file.fileUrl,
        fileId: 'fileId' in file ? file.fileId : 0,
      })
    }

    return {
      historyId: history.historyId ?? 0,
      date: parseIsoDateTime(history.date) ?? '',
      inputType: history.inputType ?? '',
      actionType: history.actionType ?? '',
      content: history.content ?? '',
      employee: history.employee ?? '',
      createdBy: history.createdBy ?? '',
      attachments: attachments,
    }
  }
  convertToTicketModel(ticket: TicketResponse): Ticket {
    return {
      ticketId: ticket.ticketId ?? 0,
      description: ticket.description ?? '',
      date: parseIsoDate(ticket.date) ?? '',
      departmentId: ticket.departmentId ?? 0,
      department: ticket.department ?? '',
      departmentsub: ticket.departmentSub ?? '',
      statusId: ticket.statusId ?? '0',
      status: ticket.status ?? '',
      history: [],
      ticketLinks: 'ticketLinks' in ticket ? ticket.ticketLinks : [],
      priority: ticket.priority ?? 4,
      timeOpened: ticket.timeOpened ?? '',
      resolution: ticket.resolution ?? '',
      closed_on: ticket.dateClosed ? parseIsoDate(ticket.dateClosed) : '',
      is_archived: !!ticket.isArchived,
      createdBy: ticket.createdBy ?? '',
      zabbix_link: ticket.zabbix_link ?? '',
    }
  }
}
export default new TicketResponseTranslator()
